<template>
  <div id="search-section">
    <!-- search form at top of page, desktop (> sm) view -->
    <div class="twcs-bg-white sm:twcs-p-2 md:twcs-pb-6">
      <div class="twcs-px-6 twcs-py-0 sm:twcs-pb-4 twcs-space-y-6 sm:twcs-pt-4 md:twcs-pt-8">
        <div class="twcs-grid twcs-grid-cols-12">
          <div class="twcs-flex md:twcs-hidden twcs-col-span-6 sm:twcs-col-span-1 twcs-my-auto twcs-mr-auto twcs-p-0">
            <button
              type="button"
              @click="$emit('categoriesModalOpenOnClick', true)"
              class="twcs-text-gray-500 hover:twcs-text-gray-500 focus-visible:twcs-outline-none focus-visible:twcs-ring-1 focus-visible:twcs-ring-offset-1 focus-visible:twcs-ring-kctcs-navy-500"
            >
              <span class="twcs-sr-only">Show Categories</span>
              <svg class="twcs-h-10 twcs-w-10 twcs-fill-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
          <!-- On mobile, filters are hidden -->
          <div class="twcs-hidden sm:twcs-flex twcs-col-span-10 md:twcs-col-span-11">
            <div class="twcs-grid twcs-justify-items-center twcs-grid-cols-2 md:twcs-grid-cols-3 lg:twcs-grid-cols-4 xl:twcs-grid-cols-5 2xl:twcs-grid-cols-6 twcs-gap-2">
              <!-- College selection dropdown -->
              <Dropdown
                v-if="filterSearchStore.showCollegeFilter"
                text="College"
                source="college"
                :options="filterSearchStore.options.college"
                :values="filterSearchStore.selected.college"
                :loading="filterSearchStore.options.loading.college"
                :multiselect="true"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onCollegeFilterChangeDone"
              />
              <!-- Term selection dropdown -->
              <Dropdown
                text="Term"
                source="term"
                :options="filterSearchStore.options.term"
                :values="filterSearchStore.selected.term"
                :loading="filterSearchStore.options.loading.term"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onTermFilterChangeDone"
              />
              <!-- Starts On selection dropdown -->
              <DropdownByGroup
                text="Starts In"
                source="startsOn"
                catch-all-category="All Months"
                :options="filterSearchStore.options.startsOn"
                :values="filterSearchStore.selected.startsOn"
                :loading="filterSearchStore.options.loading.startsOn"
                :multiselect="true"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onStartsOnFilterChangeDone"
              />
              <template v-if="filterSearchStore.options.campus.length > 2">
                <!-- Campus selection dropdown -->
                <Dropdown
                  text="Campus"
                  source="campus"
                  v-if="!filterSearchStore.showCollegeFilter"
                  :options="filterSearchStore.options.campus"
                  :values="filterSearchStore.selected.campus"
                  :loading="filterSearchStore.options.loading.campus"
                  @filter-changed="onFilterChange"
                  @filters-finished-changing="onCampusFilterChangeDone"
                />
              </template>
              <!-- Display selection dropdown -->
              <Dropdown
                text="Display"
                source="enrollable"
                :options="filterSearchStore.options.enrollable"
                :values="filterSearchStore.selected.enrollable"
                :loading="filterSearchStore.options.loading.enrollable"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onEnrollableFilterChangeDone"
              />
              <!-- Format selection dropdown -->
              <Dropdown
                text="Format"
                source="format"
                :options="filterSearchStore.options.format"
                :values="filterSearchStore.selected.format"
                :loading="filterSearchStore.options.loading.format"
                :multiselect="true"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onFormatFilterChangeDone"
              />
              <!-- Days selection dropdown -->
              <Dropdown
                text="Days"
                source="days"
                :options="filterSearchStore.options.days"
                :values="filterSearchStore.selected.days"
                :loading="filterSearchStore.options.loading.days"
                :multiselect="true"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onDaysFilterChangeDone"
              />
              <!-- Subject selection dropdown -->
              <Dropdown
                text="Subject"
                source="subject"
                :options="filterSearchStore.options.subject"
                :values="filterSearchStore.selected.subject"
                :loading="filterSearchStore.options.loading.subject"
                :multiselect="true"
                :show-active="true"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onSubjectFilterChangeDone"
              />
              <!-- Course selection dropdown -->
              <DropdownByGroup
                text="Course"
                source="course"
                catch-all-category="All Courses"
                :options="filterSearchStore.options.course"
                :values="filterSearchStore.selected.course"
                :loading="filterSearchStore.options.loading.course"
                :multiselect="true"
                :show-active="true"
                @filter-changed="onFilterChange"
                @filters-finished-changing="onCourseFilterChangeDone"
              />
            </div>
          </div>
          <div class="twcs-col-span-6 sm:twcs-col-span-1 twcs-flex twcs-ml-auto twcs-my-auto twcs-p-0">
            <button @click="$emit('searchModalOpenOnClick', true)" class="twcs-text-gray-500 hover:twcs-text-gray-500 focus-visible:twcs-outline-none focus-visible:twcs-ring-1 focus-visible:twcs-ring-offset-1 focus-visible:twcs-ring-kctcs-navy-500">
              <span class="twcs-sr-only">Show Filters</span>
              <svg class="twcs-w-10 twcs-h-10 twcs-transform twcs-rotate-90 twcs-fill-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
              </svg>
            </button>
          </div>
        </div>
        <div class="twcs-hidden sm:twcs-block twcs-text-left twcs-mt-2 md:twcs-mt-6">
          <h2 id="selected-filters-heading" class="twcs-text-gray-500 twcs-text-base twcs-font-medium twcs-tracking-wide">Selected Filters</h2>
          <ul aria-labelledby="selected-filters-heading" class="twcs-flex twcs-flex-col sm:twcs-flex-row sm:twcs-flex-wrap mt-1">
            <li
              :aria-label="filter.typeText.charAt(0).toUpperCase() + filter.typeText.slice(1) + ': ' + filter.text"
              v-for="filter in filterSearchStore.filtersSelected.filter(filter => filterSearchStore.showCollegeFilter || filter.type !== 'college')"
              :key="filter.type + filter.text"
              class="twcs-realitve twcs-flex twcs-shadow-sm twcs-rounded-md twcs-mr-2 twcs-mt-2"
            >
              <div class="twcs-flex-1 twcs-flex twcs-items-center jtwcs-ustify-between twcs-border twcs-border-gray-200 twcs-bg-white twcs-truncate">
                <div class="twcs-flex-1 twcs-px-4 twcs-py-2 twcs-text-base twcs-truncate">
                  <span class="twcs-text-gray-900 twcs-font-medium">
                    {{ filter.text }}
                  </span>
                  <p class="twcs-text-gray-500">{{ filter.typeText.charAt(0).toUpperCase() + filter.typeText.slice(1) }}</p>
                </div>
                <div class="twcs-flex-shrink-0 twcs-pr-2">
                  <button
                    type="button"
                    @click.prevent="onRemoveFilter(filter)"
                    @keydown.enter.stop.prevent="onRemoveFilter(filter)"
                    @keydown.space.stop.prevent="onRemoveFilter(filter)"
                    class="twcs-w-8 twcs-h-8 twcs-bg-white twcs-inline-flex twcs-items-center twcs-justify-center twcs-text-gray-400 twcs-rounded-full hover:twcs-text-gray-500 focus-visible:twcs-outline-none focus-visible:twcs-ring-2 focus-visible:twcs-ring-offset-2 focus-visible:twcs-ring-kctcs-navy-500"
                  >
                    <span class="twcs-sr-only">Remove filter</span>
                    <!-- Heroicon name: solid/x -->
                    <svg class="twcs-h-5 twcs-w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </li>
            <li aria-label="Remove All Filters" class="twcs-realitve twcs-flex twcs-shadow-sm twcs-rounded-md twcs-mr-2 twcs-mt-2">
              <div class="twcs-flex-1 twcs-flex twcs-items-center jtwcs-ustify-between twcs-border twcs-border-gray-200 twcs-bg-white twcs-truncate">
                <div class="twcs-flex-1 twcs-px-4 twcs-py-2 twcs-text-base twcs-truncate">
                  <button
                    type="button"
                    @click.prevent="filterSearchStore.removeAllFilters()"
                    @keydown.enter.stop.prevent="filterSearchStore.removeAllFilters()"
                    @keydown.space.stop.prevent="filterSearchStore.removeAllFilters()"
                    class="hover:twcs-text-gray-500 focus-visible:twcs-outline-none focus-visible:twcs-ring-2 focus-visible:twcs-ring-offset-2 focus-visible:twcs-ring-kctcs-navy-500"
                  >
                    <span class="twcs-text-gray-900 twcs-font-medium">
                      Remove All Filters
                    </span>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Dropdown from '@/components/Dropdown.vue';
import DropdownByGroup from '@/components/DropdownByGroup.vue';
import { useFilterSearchStore } from '@/stores/filter-search.js';

let filterSearchStore = useFilterSearchStore();

defineEmits([
	'searchModalOpenOnClick',
	'categoriesModalOpenOnClick',
]);

function onFilterChange(payload) {
	filterSearchStore.patchFilterSelection(payload);
}

function onRemoveFilter(filter) {
	filterSearchStore.removeFilter({
		source: filter.type,
		index: filter.index,
		key: filter.hasOwnProperty('key') ? filter.key : null,
	});
}

function onCollegeFilterChangeDone() {
	filterSearchStore.commitFilter('college');
}

function onTermFilterChangeDone() {
	filterSearchStore.commitFilter('term');
}

function onStartsOnFilterChangeDone() {
	filterSearchStore.commitFilter('startsOn');
}

function onCampusFilterChangeDone() {
	filterSearchStore.commitFilter('campus');
}

function onEnrollableFilterChangeDone() {
	filterSearchStore.commitFilter('enrollable');
}

function onFormatFilterChangeDone() {
	filterSearchStore.commitFilter('format');
}

function onDaysFilterChangeDone() {
	filterSearchStore.commitFilter('days');
}

function onSubjectFilterChangeDone() {
	filterSearchStore.commitFilter('subject');
}

function onCourseFilterChangeDone() {
	filterSearchStore.commitFilter('course');
}
</script>
